import { Pipe, PipeTransform } from '@angular/core';
import { FindPathResponseV2 } from '@cue/navigation-services';
import { LocalizedString } from '@cue/api';

export interface AreaBasicInfo {
  name: LocalizedString;
  areaId: number;
  enterPortalCategoryName?: LocalizedString;
  enterPortalCategoryIcon?: string;
  isHideInNavigation: boolean;
  nextItemWillBeHideInNavigation: boolean;
  //important to know skip count for future calculation of areaGroupIndexes for activeRoute computations
  skipCount?: number;
  breadcrumbList: LocalizedString[];
}

export interface NavigationBarDataV2 {
  targetName: LocalizedString;
  areaList: AreaBasicInfo[];
  targetGuid: string;
  targetResourceId: number;
}

@Pipe({
  name: 'navigationBar',
  standalone: true,
})
export class NavigationBarPipe implements PipeTransform {
  transform(pathResponse: FindPathResponseV2): NavigationBarDataV2 {
    return {
      targetName: pathResponse?.path?.length > 0 ? pathResponse.path[pathResponse.path.length - 1].mapName : null,
      areaList: pathResponse?.pathInstructions?.map((x) => {
        const lastInstruction = x.instructions[x.instructions.length - 1];
        const lastInstructionPointIdx = lastInstruction.points[lastInstruction.points.length - 1];

        const lastPointForCurrentArea = pathResponse.path[lastInstructionPointIdx];
        const isLastPointOfTheRoute = lastInstructionPointIdx === pathResponse.path.length - 1;
        return {
          areaId: x.areaId,
          name: pathResponse.areasInfo.find((y) => y.areaId === x.areaId).name,
          enterPortalCategoryName: !isLastPointOfTheRoute ? lastPointForCurrentArea?.categoryName : null,
          enterPortalCategoryIcon: !isLastPointOfTheRoute ? lastPointForCurrentArea?.categoryIcon : null,
          isHideInNavigation: lastPointForCurrentArea?.hideInNavigation,
          nextItemWillBeHideInNavigation: !isLastPointOfTheRoute
            ? pathResponse.path[lastInstructionPointIdx + 1].hideInNavigation
            : false,
          breadcrumbList: pathResponse.areasInfo.filter((areaInfo) => areaInfo.areaId === x.areaId)[0].breadcrumb,
        };
      }),
      targetGuid: pathResponse.targetGUID,
      targetResourceId: pathResponse.targetResourceId,
    };
  }
}
